import React from 'react';
import { Section } from './ui/Section';
export function MechanismSection() {
  return <Section data-id="element-90">
      <h2 className="text-3xl md:text-4xl font-serif text-cream-50 mb-8 text-center" data-id="element-91">
        El mecanismo que lo hace diferente:{' '}
        <span className="text-amber-500" data-id="element-92">BVV</span>
      </h2>

      <div className="space-y-8" data-id="element-93">
        <div className="text-center p-6 bg-warm-800 rounded-xl border border-warm-700" data-id="element-94">
          <p className="text-2xl md:text-3xl font-bold text-cream-50 tracking-wide mb-2" data-id="element-95">
            Bajar – Vaciar – Volver
          </p>
          <p className="text-amber-500 font-medium" data-id="element-96">Protocolo de 7 minutos</p>
        </div>

        <div className="space-y-6" data-id="element-97">
          <div className="flex" data-id="element-98">
            <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-warm-800 border border-amber-500/30 text-amber-500 font-serif font-bold text-xl mr-4" data-id="element-99">
              1
            </div>
            <div data-id="element-100">
              <h3 className="text-xl font-bold text-cream-50 mb-1" data-id="element-101">
                Bajar la alarma del cuerpo
              </h3>
              <p className="text-cream-100 opacity-80" data-id="element-102">
                Para que el sueño vuelva a ser posible.
              </p>
            </div>
          </div>

          <div className="flex" data-id="element-103">
            <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-warm-800 border border-amber-500/30 text-amber-500 font-serif font-bold text-xl mr-4" data-id="element-104">
              2
            </div>
            <div data-id="element-105">
              <h3 className="text-xl font-bold text-cream-50 mb-1" data-id="element-106">
                Vaciar la mente
              </h3>
              <p className="text-cream-100 opacity-80" data-id="element-107">
                Sin escribir páginas, sin terapia, sin pelear.
              </p>
            </div>
          </div>

          <div className="flex" data-id="element-108">
            <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-full bg-warm-800 border border-amber-500/30 text-amber-500 font-serif font-bold text-xl mr-4" data-id="element-109">
              3
            </div>
            <div data-id="element-110">
              <h3 className="text-xl font-bold text-cream-50 mb-1" data-id="element-111">
                Volver al cuerpo
              </h3>
              <p className="text-cream-100 opacity-80" data-id="element-112">
                Para salir de la espiral y re-entrar al sueño.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-gradient-to-r from-amber-900/20 to-transparent border-l-4 border-amber-500 rounded-r-lg" data-id="element-113">
          <p className="text-lg text-cream-50" data-id="element-114">
            Y lo mejor:{' '}
            <span className="font-bold text-amber-500" data-id="element-115">
              no depende de "estar motivada".
            </span>
            <br data-id="element-116" />
            Depende de tener el plan a mano.
          </p>
        </div>
      </div>
    </Section>;
}